export default "__VITE_ASSET__6a94589a__"